export default __webpack_public_path__ + "static/media/Note.b2e20460.svg";